import { render, staticRenderFns } from "./PointLogModal.vue?vue&type=template&id=a4d55122"
import script from "./PointLogModal.vue?vue&type=script&lang=js"
export * from "./PointLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports